// extracted by mini-css-extract-plugin
module.exports = {"videoTitle":"video-module--videoTitle--2eF52","videoWrapper":"video-module--videoWrapper--1krQX","videoIframe":"video-module--videoIframe--72k38"};